import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import AuditoriaService from "service/auditoria5s/AuditoriaService";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    data: ItemClasseAuditoria;
    value: ItemClasseAuditoria;
    onChange: (value: ItemClasseAuditoria) => void;
    onConfirm: () => void;
}
export default function ModalRespostaItemAuditoria(props: Props) {

    const { msgAlerta, msgInfo } = useToastContext();

    function confirmar() {
        if (!props.value) {
            msgAlerta("", "Informe a resposta");
            return;
        }
        props.setVisible(false);
        props.onConfirm();
    }

    return (

        <Dialog visible={props.visible} onHide={() => props.setVisible(false)} header="Resposta obrigatória" style={{ width: '50vw' }} footer={
            <>
                <Button onClick={() => props.setVisible(false)}>Fechar</Button>
                <Button disabled={!props.value} onClick={() => confirmar()}>Confirmar</Button>
            </>
        }
        >
            <div style={{ display: "flex", flexDirection: "column" }}>

                <Label>Resposta</Label>
                {props.value.requisitoAuditoria.permiteResposta && props.value.tipoResposta == "TEXTO" ? <InputTextarea
                    placeholder="Digite a resposta"
                    onChange={(e) => { props.onChange({ ...props.value, resposta: e.target.value }) }} />
                    : null}
                {props.value.requisitoAuditoria.permiteResposta && props.value.tipoResposta == "MULTI_ESCOLHA" ?
                    props.value.opcoesResposta && props.value.opcoesResposta.map((opcao, index) => <div style={{display: "flex", alignItems: "center"}} key={index}>
                        <RadioButton value={opcao.id} checked={opcao.escolhida} onChange={() => {
                            props.value.opcoesResposta.forEach(o => o.escolhida = false);
                            opcao.escolhida = true;
                            props.onChange({ ...props.value })
                        }} />
                        <label>{opcao.resposta}</label>
                    </div>
                    )
                    : null}
            </div>
        </Dialog>
    )
}